import {
  EmptyStateNoResultIllustration,
  EmptyStateProps,
} from '@ardoq/status-ui';
import { OnButtonClick } from './types';
import { PrimaryButton } from '@ardoq/button';
import { t, type I18nLocale } from '@ardoq/i18n';

type NoDataAvailableInDiscoverJourneyArgs = {
  handleNavigateToDiscoverHomeClick: OnButtonClick;
  i18nLocale: I18nLocale;
};

export const noDataAvailableInDiscoverJourney = ({
  handleNavigateToDiscoverHomeClick,
  i18nLocale,
}: NoDataAvailableInDiscoverJourneyArgs): EmptyStateProps => ({
  media: <EmptyStateNoResultIllustration />,
  title: t(
    i18nLocale,
    'tabview:graphViews.emptyStateLayout.noDataAvailableInDiscoverJourney.title',
    'There is no data to show'
  ),
  description: t(
    i18nLocale,
    'tabview:graphViews.emptyStateLayout.noDataAvailableInDiscoverJourney.description',
    'The current viewpoint you have opened seems empty. Try choosing a different viewpoint or go back to the home page.'
  ),
  children: (
    <PrimaryButton onClick={handleNavigateToDiscoverHomeClick}>
      {t(
        i18nLocale,
        'tabview:graphViews.emptyStateLayout.noDataAvailableInDiscoverJourney.goToHomePage',
        'Go to home page'
      )}
    </PrimaryButton>
  ),
});
